import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

export enum Machine {
  LorixOne256 = 'lorix-one-256',
  LorixOne512 = 'lorix-one-512',
}

@jsonObject
export class OsInfo {

  @jsonMember({name: 'name'})
  public Name!: string;

  @jsonMember({name: 'version'})
  public Version!: string;

  @jsonMember({name: 'versionNormalized'})
  public VersionNormalized!: string;

  @jsonMember({name: 'versionName'})
  public VersionName!: string;

  @jsonMember({name: 'kernelVersion'})
  public KernelVersion!: string;

  @jsonMember({name: 'kernelBuildDate'})
  public KernelBuildDate!: string;

  @jsonMember({name: 'sourcesHash'})
  public SourcesHash!: string;

  @jsonMember({name: 'sourcesDate'})
  public SourcesDate!: Date;

  @jsonMember({name: 'buildDate'})
  public BuildDate!: Date;

  @jsonMember({name: 'machine'})
  public Machine!: Machine;

  @jsonMember({name: 'variant'})
  public Variant!: string;

  @jsonMember({name: 'audience'})
  public Audience!: string;

}
